import clsx from "clsx";
import { MouseEventHandler } from "react";

import { useStyles } from "@/common/components/ArchivePage/Preset/PresetStyles";
import * as FullStory from "@/utilities/hooks/fullstory";


interface PresetThumbnailProps {
    imageUrl: string,
    datetimeRecorded: string,
    offset:number,
    maxWidth: string | number,
    onMouseEnter?: MouseEventHandler<HTMLElement>,
    onMouseLeave?: MouseEventHandler<HTMLElement>,
    onMouseDown?: MouseEventHandler<HTMLElement>,
    onMouseUp?: MouseEventHandler<HTMLElement>
}


export default function PresetThumbnail(props: PresetThumbnailProps) {
    const classes = useStyles();

    return (
        <div
            className={clsx(classes.thumbnailImage, FullStory.names.classes.history.thumbnail)}
            style={{
                left: props.offset,
                maxWidth: props.maxWidth,
            }}
            onMouseDown={props.onMouseDown}
            onMouseEnter= {props.onMouseEnter}
            onMouseLeave={props.onMouseLeave}
            onMouseUp={props.onMouseUp}
        >
            <img src={props.imageUrl} alt="" className={classes.image} draggable={false} />
        </div>
    );
}
